export const ACTIVITY_ACTIONS = {
    // Auth
    LOGIN: 'auth.login',
    LOGIN_FAILED: 'auth.login_failed',
    LOGOUT: 'auth.logout',
    PASSWORD_RESET: 'auth.password_reset',
    PASSWORD_CHANGED: 'auth.password_changed',
    TOKEN_REFRESH: 'auth.token_refresh',
    // Entity CRUD
    LEAD_CREATED: 'entity.lead_created',
    LEAD_UPDATED: 'entity.lead_updated',
    LEAD_STATUS_CHANGED: 'entity.lead_status_changed',
    LEAD_EXPORTED: 'entity.lead_exported',
    ORG_CREATED: 'entity.org_created',
    ORG_UPDATED: 'entity.org_updated',
    ORG_TRANSITION: 'entity.org_transition',
    BUSINESS_CREATED: 'entity.business_created',
    BUSINESS_UPDATED: 'entity.business_updated',
    LOCATION_CREATED: 'entity.location_created',
    LOCATION_UPDATED: 'entity.location_updated',
    DOMAIN_CREATED: 'entity.domain_created',
    DOMAIN_DELETED: 'entity.domain_deleted',
    // User management
    USER_INVITED: 'user.invited',
    USER_CREATED: 'user.created',
    USER_ROLE_CHANGED: 'user.role_changed',
    USER_LOCKED: 'user.locked',
    USER_UNLOCKED: 'user.unlocked',
    // Integrations
    INTEGRATION_CREATED: 'integration.created',
    INTEGRATION_UPDATED: 'integration.updated',
    INTEGRATION_REMOVED: 'integration.removed',
    INTEGRATION_TESTED: 'integration.tested',
    TAG_MAPPING_CREATED: 'integration.tag_mapping_created',
    TAG_MAPPING_DELETED: 'integration.tag_mapping_deleted',
    // Config
    NOTIFICATION_CONFIG_UPDATED: 'config.notification_updated',
    SETTINGS_UPDATED: 'config.settings_updated',
    FEATURE_FLAG_SET: 'config.feature_flag_set',
    DRIP_SEQUENCE_CREATED: 'config.drip_sequence_created',
    DRIP_SEQUENCE_UPDATED: 'config.drip_sequence_updated',
    // Compliance
    OPT_OUT: 'compliance.opt_out',
    DATA_EXPORT: 'compliance.data_export',
    DATA_ERASURE: 'compliance.data_erasure',
    CONSENT_UPDATED: 'compliance.consent_updated',
    // System
    NOTIFICATION_SENT: 'system.notification_sent',
    NOTIFICATION_FAILED: 'system.notification_failed',
    EVENT_DEAD_LETTER: 'system.event_dead_letter',
    // Agent
    AGENT_TASK_TRIGGERED: 'agent.task_triggered',
    AGENT_WEBHOOK_DELIVERED: 'agent.webhook_delivered',
    AGENT_WEBHOOK_FAILED: 'agent.webhook_failed',
    AGENT_SITE_DEPLOYED: 'agent.site_deployed',
    AGENT_SITE_DEPLOY_FAILED: 'agent.site_deploy_failed',
    AGENT_SITE_EDIT_REQUESTED: 'agent.site_edit_requested',
    AGENT_SITE_EDIT_CONFIRMED: 'agent.site_edit_confirmed',
    AGENT_SITE_CONFIG_CHANGED: 'agent.site_config_changed',
    AGENT_NOTIFICATION_SENT: 'agent.notification_sent',
    AGENT_NOTIFICATION_FAILED: 'agent.notification_failed',
    AGENT_DRIP_STEP_SENT: 'agent.drip_step_sent',
    AGENT_EVENT_DEAD_LETTERED: 'agent.event_dead_lettered',
};
export const ACTION_TO_CATEGORY = {};
for (const [, value] of Object.entries(ACTIVITY_ACTIONS)) {
    const category = value.split('.')[0];
    ACTION_TO_CATEGORY[value] = category;
}
//# sourceMappingURL=activity.js.map